(function() {
    'use strict';

    /**
     * HomeController - contrôleur de la page d'accueil
     */
    angular
        .module('observatoireApp')
.controller('HomeController', ['$scope', '$http', '$timeout', '$interval', '$state', 'MockDataService', 'VideothequeService', 'PublicationsService', 'NewsletterService', '$sce', 'GlobalSearchService', 'ActualitesService', function($scope, $http, $timeout, $interval, $state, MockDataService, VideothequeService, PublicationsService, NewsletterService, $sce, GlobalSearchService, ActualitesService) {
  
  $scope.$state = $state;
  $scope.featuredDatasets = [];
  $scope.topOrganizations = [];
  $scope.recentPublications = [];
  $scope.recentVideos = [];

  // ── Recherche globale ──────────────────────────────────
  $scope.searchQuery     = '';
  $scope.showDropdown    = false;
  $scope.dropdownLoading = false;
  $scope.dropdownResults = [];
  var searchDebounce     = null;

  $scope.onSearchInput = function() {
    var q = ($scope.searchQuery || '').trim();
    if (q.length < 2) {
      $scope.showDropdown    = false;
      $scope.dropdownResults = [];
      return;
    }
    $scope.showDropdown    = true;
    $scope.dropdownLoading = true;
    $timeout.cancel(searchDebounce);
    searchDebounce = $timeout(function() {
      GlobalSearchService.quickSearch(q).then(function(results) {
        $scope.dropdownResults = results;
        $scope.dropdownLoading = false;
      }).catch(function() {
        $scope.dropdownLoading = false;
        $scope.dropdownResults = [];
      });
    }, 280);
  };

  $scope.onSearchFocus = function() {
    if (($scope.searchQuery || '').trim().length >= 2) {
      $scope.showDropdown = true;
    }
  };

  $scope.closeDropdown = function() {
    $scope.showDropdown = false;
  };

  $scope.goToResult = function(item) {
    $scope.showDropdown = false;
    $state.go(item.state);
  };

  $scope.search = function() {
    $scope.showDropdown = false;
    if ($scope.searchQuery && $scope.searchQuery.trim().length >= 2) {
      $state.go('main.search', { q: $scope.searchQuery.trim() });
    }
  };
  $scope.loading = {
    datasets: true,
    organizations: true,
    publications: true,
    videos: true,
    actualites: true
  };
  $scope.homeActualites = [];
  
  // URLs des applications (à remplacer par les URLs réelles)
  $scope.appUrls = {
    ios: 'https://apps.apple.com/app/observatoire-tchad',
    android: 'https://play.google.com/store/apps/details?id=org.observatoire.tchad'
  };
  
  // Fonction pour charger toutes les données nécessaires
  function loadAllData() {
    // Charger les vidéos récentes
    //A decommenter -- Ousmane TIDJANI CHERIF
    loadRecentVideos();
    
    // Charger les jeux de données mis en avant
    $http.get('/api/datasets/featured')
      .then(function(response) {
        $scope.featuredDatasets = response.data || [];
        $scope.loading.datasets = false;
      })
      .catch(function() {
        console.info('Utilisation des données simulées pour les jeux de données');
        $scope.featuredDatasets = MockDataService.getFeaturedDatasets();
        $scope.loading.datasets = false;
      });
    
    // Charger les organisations principales
    $http.get('/api/organizations/top')
      .then(function(response) {
        $scope.topOrganizations = response.data || [];
        $scope.loading.organizations = false;
      })
      .catch(function() {
        console.info('Utilisation des données simulées pour les organisations');
        $scope.topOrganizations = MockDataService.getTopOrganizations();
        $scope.loading.organizations = false;
      });
    
    // Charger les publications récentes
    PublicationsService.getRecentPublications(4)
      .then(function(publications) {
        $scope.recentPublications = publications;
        $scope.loading.publications = false;
      })
      .catch(function(error) {
        console.error('Erreur lors du chargement des publications récentes:', error);
        console.info('Utilisation des données simulées pour les publications');
        $scope.recentPublications = MockDataService.getRecentPublications();
        $scope.loading.publications = false;
      });

      // Charger les publications en vedette
    PublicationsService.getFeaturedPublications(4)
    .then(function(publications) {
      $scope.featuredPublications = publications;
      $scope.loading.publications = false;
    })
    .catch(function(error) {
      console.error('Erreur lors du chargement des publications en vedette:', error);
      console.info('Utilisation des données simulées pour les publications');
      $scope.featuredPublications = MockDataService.getFeaturedPublications();
      $scope.loading.publications = false;
    });
  }
  
  loadRecentActualites();

  // Charger les données
  loadAllData();
  
  function loadRecentActualites() {
    ActualitesService.getRecentActualites(3)
      .then(function(actualites) {
        $scope.homeActualites = actualites;
        $scope.loading.actualites = false;
      })
      .catch(function() {
        $scope.loading.actualites = false;
      });
  }

  $scope.selectedActualite = null;

  $scope.formatDate = function(dateInput) {
    if (!dateInput) return 'Date inconnue';
    var date;
    if (Array.isArray(dateInput) && dateInput.length >= 3) {
      date = new Date(dateInput[0], dateInput[1] - 1, dateInput[2],
        dateInput.length > 3 ? dateInput[3] : 0,
        dateInput.length > 4 ? dateInput[4] : 0,
        dateInput.length > 5 ? dateInput[5] : 0);
    } else {
      date = new Date(dateInput);
    }
    if (isNaN(date.getTime())) return 'Date inconnue';
    var day   = date.getDate().toString().padStart(2, '0');
    var month = (date.getMonth() + 1).toString().padStart(2, '0');
    return day + '/' + month + '/' + date.getFullYear();
  };

  $scope.getShareUrl = function(id) {
    return window.location.origin + '/#!/actualites/' + id;
  };

  $scope.showActualiteDetail = function(actu) {
    if (!actu || !actu.id) return;
    ActualitesService.getActualiteById(actu.id)
      .then(function(detail) {
        $scope.selectedActualite = detail;
        if (!$scope.selectedActualite.title)   $scope.selectedActualite.title   = 'Sans titre';
        if (!$scope.selectedActualite.summary) $scope.selectedActualite.summary = '';
        if (!$scope.selectedActualite.image)   $scope.selectedActualite.image   = 'assets/images/placeholder.jpg';
        if (!$scope.selectedActualite.category) $scope.selectedActualite.category = '';
        $scope.selectedActualite.trustedContent = $sce.trustAsHtml(
          $scope.selectedActualite.content || '<p>Aucun contenu disponible.</p>'
        );
        if (!$scope.$$phase) $scope.$apply();
        var el = document.getElementById('homeActuDetailModal');
        if (el) bootstrap.Modal.getOrCreateInstance(el).show();
      })
      .catch(function(err) {
        console.error('Erreur chargement actualité:', err);
      });
  };

  $scope.closeActualiteModal = function() {
    var el = document.getElementById('homeActuDetailModal');
    if (el) { var m = bootstrap.Modal.getInstance(el); if (m) m.hide(); }
  };

  // Charger les vidéos récentes
  function loadRecentVideos() {
    $scope.loading.videos = true;
    VideothequeService.getVideos().then(function(videos) {
      // Trier par date (en supposant que le format de date est 'YYYY-MM-DD')
      videos.sort(function(a, b) {
        return new Date(b.date) - new Date(a.date);
      });
      // Prendre les 6 plus récentes
      $scope.recentVideos = videos.slice(0, 6);
      $scope.loading.videos = false;
    });
  }
  
  // Visualiser une vidéo
  $scope.voirVideo = function(video) {
    $scope.videoSelectionnee = video;
      
    // Créer une URL sécurisée pour l'intégration iframe
    $scope.videoSelectionnee.urlSecurisee = $sce.trustAsResourceUrl(`https://www.youtube.com/embed/${video.videoId}`);
      
    // Ouvrir le modal (Bootstrap 5 API native)
    var modalEl = document.getElementById('modalVideo');
    if (modalEl) {
      var modal = bootstrap.Modal.getOrCreateInstance(modalEl);
      modal.show();
    }
  };
  
  /**
   * Ferme le modal vidéo
   */
  $scope.fermerVideo = function() {
    var modalEl = document.getElementById('modalVideo');
    if (modalEl) {
      var modal = bootstrap.Modal.getInstance(modalEl);
      if (modal) modal.hide();
    }
      
    // Réinitialiser après la fermeture du modal
    $timeout(function() {
      $scope.videoSelectionnee = null;
    }, 300);
  };
  
  /**
   * Partage la vidéo sur Facebook
   */
  $scope.partagerFacebook = function(video) {
    const url = encodeURIComponent(`https://www.youtube.com/watch?v=${video.videoId}`);
    const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
    window.open(shareUrl, '_blank', 'width=600,height=400');
  };
  
  /**
   * Partage la vidéo sur Twitter
   */
  $scope.partagerTwitter = function(video) {
    const url = encodeURIComponent(`https://www.youtube.com/watch?v=${video.videoId}`);
    const texte = encodeURIComponent(`${video.titre} - OTFIP`);
    const shareUrl = `https://twitter.com/intent/tweet?url=${url}&text=${texte}`;
    window.open(shareUrl, '_blank', 'width=600,height=400');
  };
  
  /**
   * Partage la vidéo par email
   */
  $scope.partagerEmail = function(video) {
    const url = `https://www.youtube.com/watch?v=${video.videoId}`;
    const sujet = encodeURIComponent(`Vidéo OTFIP: ${video.titre}`);
    const corps = encodeURIComponent(`Découvrez cette vidéo de l'Observatoire Tchadien des Finances Publiques: ${video.titre} \n\n${url}`);
    
    window.location.href = `mailto:?subject=${sujet}&body=${corps}`;
  };
  
  /**
   * Visualiser une publication
   */
  $scope.visualizePublication = function(publication) {
    if (publication && publication.fileUrl) {
      // Définir la publication sélectionnée
      $scope.selectedPublication = publication;
      
      // Pour les PDF, nous devons autoriser l'URL avec $sce
      if (publication.fileType === 'PDF') {
        $scope.trustedPdfUrl = $sce.trustAsResourceUrl(publication.fileUrl);
      }
      
      // Incrémenter le nombre de vues
      PublicationsService.incrementViews(publication.id)
        .then(function(updatedPublication) {
          // Mettre à jour la publication dans la liste
          $scope.recentPublications = $scope.recentPublications.map(function(pub) {
            if (pub.id === updatedPublication.id) {
              return angular.extend({}, pub, updatedPublication);
            }
            return pub;
          });
        })
        .catch(function(error) {
          console.error('Erreur lors de l\'incrémentation des vues', error);
        });
      
      // Ouvrir le modal (Bootstrap 5 API native)
      var pubModalEl = document.getElementById('publicationViewerModal');
      if (pubModalEl) {
        bootstrap.Modal.getOrCreateInstance(pubModalEl).show();
      }
    }
  };
  
  /**
   * Fermer le visualiseur de publication
   */
  $scope.closeViewer = function() {
    var pubModalEl = document.getElementById('publicationViewerModal');
    if (pubModalEl) {
      var pubModal = bootstrap.Modal.getInstance(pubModalEl);
      if (pubModal) pubModal.hide();
    }
    
    // Réinitialiser après la fermeture du modal
    $timeout(function() {
      $scope.selectedPublication = null;
      $scope.trustedPdfUrl = null;
    }, 300);
  };
  
  
  /**
   * Télécharger une publication
   */
  $scope.downloadPublication = function(publication) {
    if (publication && publication.fileUrl) {
      // Incrémenter le nombre de téléchargements
      PublicationsService.incrementDownloads(publication.id)
        .then(function(updatedPublication) {
          // Mettre à jour la publication dans la liste
          $scope.recentPublications = $scope.recentPublications.map(function(pub) {
            if (pub.id === updatedPublication.id) {
              return angular.extend({}, pub, updatedPublication);
            }
            return pub;
          });
        })
        .catch(function(error) {
          console.error('Erreur lors de l\'incrémentation des téléchargements', error);
        });
  
      // Créer un élément <a> temporaire pour le téléchargement
      var a = document.createElement('a');
      a.href = publication.fileUrl;
      a.download = publication.title.replace(/[^a-z0-9]/gi, '_').toLowerCase() + '.' + publication.fileType.toLowerCase();
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };
  
  /**
   * Partager une publication
   */
  $scope.sharePublication = function(publication) {
    // S'assurer que l'URL du fichier existe
    if (!publication.fileUrl) {
      alert('Impossible de partager : aucun fichier associé à cette publication.');
      return;
    }
    
    // Utiliser l'API Web Share si disponible
    if (navigator.share) {
      navigator.share({
        title: publication.title,
        text: publication.description || 'Consultez cette publication de l\'Observatoire Tchadien des Finances Publiques',
        url: publication.fileUrl
      })
      .then(() => {
        console.log('Publication partagée avec succès');
      })
      .catch((error) => console.log('Erreur lors du partage', error));
    } else {
      // Fallback si l'API Web Share n'est pas supportée
      var tempTextarea = document.createElement('textarea');
      tempTextarea.value = publication.fileUrl;
      document.body.appendChild(tempTextarea);
      tempTextarea.select();
      
      try {
        var successful = document.execCommand('copy');
        if (successful) {
          alert('L\'URL du fichier a été copiée dans votre presse-papiers. Vous pouvez maintenant la partager.');
        } else {
          alert('Impossible de copier l\'URL. Veuillez la copier manuellement : ' + publication.fileUrl);
        }
      } catch (err) {
        alert('Impossible de partager automatiquement. URL du fichier : ' + publication.fileUrl);
      }
      
      document.body.removeChild(tempTextarea);
    }
  };
  
  /**
   * Partager sur Facebook
   */
  $scope.shareOnFacebook = function(publication) {
    if (publication && publication.fileUrl) {
      const url = encodeURIComponent(publication.fileUrl);
      const shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + url;
      window.open(shareUrl, '_blank', 'width=600,height=400');
    }
  };
  
  /**
   * Partager sur Twitter
   */
  $scope.shareOnTwitter = function(publication) {
    if (publication && publication.fileUrl) {
      const url = encodeURIComponent(publication.fileUrl);
      const text = encodeURIComponent(publication.title + ' - Observatoire Tchadien des Finances Publiques');
      const shareUrl = 'https://twitter.com/intent/tweet?text=' + text + '&url=' + url;
      window.open(shareUrl, '_blank', 'width=600,height=400');
    }
  };
  
  /**
   * Partager par email
   */
  $scope.shareByEmail = function(publication) {
    if (publication && publication.fileUrl) {
      const subject = encodeURIComponent('Publication: ' + publication.title);
      const body = encodeURIComponent('Découvrez cette publication de l\'Observatoire Tchadien des Finances Publiques: ' + publication.title + '\n\n' + publication.fileUrl);
      window.location.href = 'mailto:?subject=' + subject + '&body=' + body;
    }
  };
  
  /**
   * Vérifie si une vidéo est en favori
   */
  $scope.estFavori = function(videoId) {
    return VideothequeService.estFavori(videoId);
  };
  
  /**
   * Ajoute ou supprime une vidéo des favoris
   */
  $scope.toggleFavori = function(videoId) {
    return VideothequeService.toggleFavori(videoId);
  };
  
  /**
   * Vérifie si une vidéo est téléchargeable
   */
  $scope.estTelechargeable = function(video) {
    return video && video.downloadable === true;
  };
  
  // Initialisation des variables pour la newsletter
  $scope.newsletter = {
    email: ''
  };
  $scope.isSubscribing = false;
  $scope.subscriptionSuccess = false;
  $scope.subscriptionError = false;
  $scope.subscriptionErrorMessage = '';
  
  /**
   * S'abonner à la newsletter
   */
  $scope.subscribeNewsletter = function() {
    if (!$scope.newsletter || !$scope.newsletter.email) {
      console.log('Email manquant');
      return;
    }
    
    console.log('Tentative d\'abonnement avec l\'email:', $scope.newsletter.email);
    
    $scope.isSubscribing = true;
    $scope.subscriptionSuccess = false;
    $scope.subscriptionError = false;
    
    NewsletterService.addSubscriber($scope.newsletter.email)
      .then(function(response) {
        $scope.isSubscribing = false;
        $scope.subscriptionSuccess = true;
        $scope.newsletter.email = '';
        
        $timeout(function() {
          $scope.subscriptionSuccess = false;
        }, 5000);
      })
      .catch(function(error) {
        $scope.isSubscribing = false;
        $scope.subscriptionError = true;
        $scope.subscriptionErrorMessage = 'Une erreur est survenue lors de l\'inscription. Veuillez réessayer.';
        
        $timeout(function() {
          $scope.subscriptionError = false;
        }, 5000);
        
        console.error('Erreur lors de l\'abonnement à la newsletter:', error);
      });
  };
  
  /**
   * Télécharge une vidéo
   */
  $scope.telechargerVideo = function(video) {
    VideothequeService.telechargerVideo(video);
  };
  
  // Faire défiler le carousel
  $scope.scrollCarousel = function(direction) {
    $timeout(function() {
      const container = document.querySelector('.video-carousel');
      if (!container) return;
      const card = container.querySelector('.col-md-4');
      if (!card) return;
      const cardWidth = card.offsetWidth;
      const scrollAmount = direction === 'right' ? cardWidth : -cardWidth;
      
      container.scrollBy({ 
        left: scrollAmount, 
        behavior: 'smooth' 
      });
    }, 0);
  };
  
  // Variables pour contrôler l'autoscroll
  let autoScrollInterval;
  let isHovering = false;
  
  /**
   * Démarre le défilement automatique du carousel
   */
  function startAutoScroll() {
    // Vérifier que l'intervalle n'existe pas déjà
    if (!autoScrollInterval) {
      let currentPosition = 0;
      const maxPosition = $scope.recentVideos.length - 3; // Nombre de positions possibles
      
      autoScrollInterval = $interval(function() {
        if (!isHovering && $scope.recentVideos.length > 3) {
          // Récupérer la position actuelle du scroll
          const container = document.querySelector('.video-carousel');
          if (container) {
            // Calculer si nous sommes proches de la fin
            const isNearEnd = container.scrollLeft + container.clientWidth >= container.scrollWidth - 50;
            
            if (isNearEnd) {
              // Revenir au début quand on atteint la fin (boucle)
              container.scrollTo({ left: 0, behavior: 'smooth' });
              currentPosition = 0;
            } else {
              // Continuer le défilement normal
              $scope.scrollCarousel('right');
              currentPosition++;
            }
          }
        }
      }, 5000); // Défiler toutes les 5 secondes
    }
  }
  
  /**
   * Arrête le défilement automatique du carousel
   */
  function stopAutoScroll() {
    if (autoScrollInterval) {
      $interval.cancel(autoScrollInterval);
      autoScrollInterval = null;
    }
  }
  
  /**
   * Initialise les événements de survol pour le carousel
   */
  function initCarouselHoverEvents() {
    $timeout(function() {
      const carouselContainer = document.querySelector('.video-carousel-container');
      if (carouselContainer) {
        // Au survol, arrêter le défilement automatique
        carouselContainer.addEventListener('mouseenter', function() {
          isHovering = true;
        });
        
        // À la sortie, reprendre le défilement
        carouselContainer.addEventListener('mouseleave', function() {
          isHovering = false;
        });
      }
    }, 500); // Attendre que le DOM soit prêt
  }
  
  // Initialiser les graphiques après le chargement de la page
  $timeout(function() {
    initCharts();
    startAutoScroll();
    initCarouselHoverEvents();
  }, 500);
  
    /**
   * Télécharger l'application iOS
   */
  $scope.downloadIosApp = function() {
    // Ouvrir l'URL de l'App Store dans un nouvel onglet
    window.open($scope.appUrls.ios, '_blank');
    
    // Enregistrer l'événement de téléchargement (optionnel)
    console.log('Téléchargement iOS demandé');
    // Vous pourriez ajouter ici un appel à une API d'analyse ou de suivi
  };
  
  /**
   * Télécharger l'application Android
   */
  $scope.downloadAndroidApp = function() {
    // Ouvrir l'URL de Google Play Store dans un nouvel onglet
    window.open($scope.appUrls.android, '_blank');
    
    // Enregistrer l'événement de téléchargement (optionnel)
    console.log('Téléchargement Android demandé');
    // Vous pourriez ajouter ici un appel à une API d'analyse ou de suivi
  };

function initCharts() {
    if (!window.Chart) {
      console.error('Chart.js n\'est pas disponible');
      return;
    }
    
    // Récupérer les données pour les graphiques depuis notre service
    const chartData = MockDataService.getChartData();
    
    // Premier graphique - Répartition du budget par secteur
    if (document.getElementById('budgetChart')) {
      new Chart(document.getElementById('budgetChart').getContext('2d')).Pie(
        chartData.budget.data.map((value, index) => ({
          value: value,
          color: chartData.budget.colors[index],
          label: chartData.budget.labels[index]
        })), 
        { 
          responsive: true,
          animateRotate: true,
          legendTemplate: "<ul class=\"<%=name.toLowerCase()%>-legend\"><% for (var i=0; i<segments.length; i++){%><li><span style=\"background-color:<%=segments[i].fillColor%>\"></span><%if(segments[i].label){%><%=segments[i].label%><%}%></li><%}%></ul>"
        }
      );
    }
    
    // Deuxième graphique - Production pétrolière trimestrielle
    if (document.getElementById('petroleumChart')) {
      new Chart(document.getElementById('petroleumChart').getContext('2d')).Line(
        {
          labels: chartData.petroleumProduction.labels,
          datasets: [
            {
              label: chartData.petroleumProduction.datasets[0].label,
              fillColor: "rgba(74, 91, 196, 0.2)",
              strokeColor: chartData.petroleumProduction.datasets[0].borderColor,
              pointColor: chartData.petroleumProduction.datasets[0].borderColor,
              pointStrokeColor: "#fff",
              pointHighlightFill: "#fff",
              pointHighlightStroke: chartData.petroleumProduction.datasets[0].borderColor,
              data: chartData.petroleumProduction.datasets[0].data
            },
            {
              label: chartData.petroleumProduction.datasets[1].label,
              fillColor: "rgba(108, 48, 168, 0.2)",
              strokeColor: chartData.petroleumProduction.datasets[1].borderColor,
              pointColor: chartData.petroleumProduction.datasets[1].borderColor,
              pointStrokeColor: "#fff",
              pointHighlightFill: "#fff",
              pointHighlightStroke: chartData.petroleumProduction.datasets[1].borderColor,
              data: chartData.petroleumProduction.datasets[1].data
            }
          ]
        },
        { 
          responsive: true,
          bezierCurve: true,
          pointDotRadius: 4,
          datasetStrokeWidth: 2
        }
      );
    }
    
    // Troisième graphique - Répartition des recettes
    if (document.getElementById('revenueChart')) {
      new Chart(document.getElementById('revenueChart').getContext('2d')).Doughnut(
        chartData.revenueDistribution.data.map((value, index) => ({
          value: value,
          color: chartData.revenueDistribution.colors[index],
          label: chartData.revenueDistribution.labels[index]
        })),
        { 
          responsive: true,
          animateRotate: true,
          animateScale: true,
          tooltipTemplate: "<%=label%>: <%= value %>%"
        }
      );
    }
    
    // Afficher les statistiques
    $scope.statistics = MockDataService.getStatistics();
  }
}]);

})();
